import { routes } from '../config/api_routes';

export const subscriptionService = {

    getSubscription: (formData) => {    
        return window.axios.post(routes.getSubscriptionApi,formData)
    },

    getSubscriptionProduct: (formData) => {    
        return window.axios.post(routes.getSubscriptionProductApi,formData)
    },
    
    getSubscriptionById: (formData) => {    
        return window.axios.post(routes.getSubscriptionByIdApi,formData)
    },
}